import React from "react";
import { TextField } from "@mui/material";
import { styled, fontSizes } from "@iventis/styles";

import { Theme } from "@emotion/react";

export const TextArea = ({
    value,
    placeholder,
    rows,
    error,
    dataTestId,
    onChange,
    onBlur,
    disabled = false,
}: {
    value?: string;
    placeholder: string;
    rows: number;
    error?: string;
    dataTestId: string;
    onBlur?: (e: unknown) => void;
    onChange: (value: string) => void;
    disabled?: boolean;
}) => (
    <TextAreaContainer>
        <TextField
            disabled={disabled}
            onBlur={onBlur}
            value={value}
            placeholder={placeholder}
            multiline
            rows={rows}
            onChange={(value) => onChange(value.target.value)}
            inputProps={{ "data-testid": dataTestId }}
        />
        <span data-testid={`${dataTestId}-error`} className="text-area-error">
            {error}
        </span>
    </TextAreaContainer>
);

const TextAreaContainer = styled.div`
    width: 100%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .MuiInputBase-root {
        padding: 5px;
    }

    .text-area-error {
        font-size: ${fontSizes.small};
        color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.error};
    }
`;
